import { render, staticRenderFns } from "./AuditNoteTable.vue?vue&type=template&id=5838bf19&scoped=true&"
import script from "./AuditNoteTable.vue?vue&type=script&lang=js&"
export * from "./AuditNoteTable.vue?vue&type=script&lang=js&"
import style0 from "./AuditNoteTable.vue?vue&type=style&index=0&id=5838bf19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5838bf19",
  null
  
)

export default component.exports